import { handleActions } from 'redux-actions';

import { removeDuplicates } from 'utils/array';
import stateUtils from 'state/utils';

import ordersActions from 'state/orders/actionCreators';
import initialState from 'state/orders/initial.state';

const orders = handleActions(
  {
    [stateUtils.RESET_ORDERS_STATE]: () => initialState,

    [ordersActions.resetData]: () => ({ ...initialState, searchText: '' }),
    [ordersActions.setData]: (
      state,
      {
        payload: {
          data: { orderIdsSorted, normalizedOrders, pages, count },
        },
      }
    ) => ({
      ...state,
      ids: removeDuplicates([...orderIdsSorted]),
      count,
      ordersById: normalizedOrders,
      pages: pages || [],
    }),

    [ordersActions.addData]: (
      state,
      {
        payload: {
          data: { orderIdsSorted, normalizedOrders, pages },
        },
      }
    ) => ({
      ...state,
      ids: removeDuplicates([...state.ids, ...orderIdsSorted]),
      ordersById: { ...(state.ordersById || {}), ...normalizedOrders },
      pages: pages || [],
    }),

    [ordersActions.resetPage]: (state) => ({ ...state, pages: [] }),
    [ordersActions.setFetching]: (state, { payload: { isFetching } }) => ({
      ...state,
      isFetching,
    }),
    [ordersActions.setSubmitting]: (state, { payload: { isSubmitting } }) => ({
      ...state,
      isSubmitting,
    }),
    [ordersActions.updateShipment]: (
      state,
      { payload: { shipment, shipmentId, orderId } }
    ) => ({
      ...state,
      ordersById: {
        ...(state.ordersById || {}),
        [orderId]: {
          ...((state.ordersById && state.ordersById[orderId]) || {}),
          shipments: [
            ...(
              (state.ordersById &&
                state.ordersById[orderId] &&
                state.ordersById[orderId].shipments) || [{ ...shipment }]
            ).map((currentShipment) => {
              if (String(shipmentId) === String(currentShipment.id))
                return { ...currentShipment, ...shipment };
              return { ...currentShipment };
            }),
          ],
        },
      },
    }),
    [ordersActions.setSearchText]: (state, { payload: { text } }) => ({
      ...state,
      searchText: text,
    }),
    [ordersActions.setUser]: (state, { payload: { user } }) => ({
      ...state,
      user: { ...user },
    }),
    [ordersActions.clearUser]: (state) => ({
      ...state,
      user: undefined,
    }),

    [ordersActions.setDate]: (state, { payload: { type, value } }) => ({
      ...state,
      [type]: value,
    }),

    [ordersActions.clearDate]: (state, { payload: { type } }) => ({
      ...state,
      [type]: undefined,
    }),
  },
  initialState
);

export default orders;
